<template>
    <DModal
        is-confirm
        is-error
        :is-awaiting-validation="true"
        :title="__('products.fulfillmentGroups.actions.update-antagonist-password.form.title')"
        :show="showModal"
        @close="close"
        @confirm="confirm"
    >
        <div style="padding: 15px;">
            <DFormRow
                :label="__('products.fulfillmentGroups.actions.update-antagonist-password.form.new_password')"
                :is-required="true"
                :error="errors.new_password"
            >
                <DInput
                    id="new_password"
                    v-model="form.new_password"
                    :is-valid="typeof errors.new_password === 'undefined' ? null : false"
                    maxlength="255"
                    type="password"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'

const emit = defineEmits(['close-modal'])

const props = defineProps({
    accountGroup: {
        type: Object,
        default: () => ({})
    },
    showModal: {
        type: Boolean,
        default: false
    }
})

const errors = ref({})

const form = useForm({
    new_password: ''
})

const close = function () {
    emit('close-modal')
    errors.value = {}
}

const confirm = function () {
    form.post(
        route('products.account-groups.update_antagonist_da_passwords', { accountGroup: props.accountGroup.id }, true),
        {
            onSuccess: () => {
                emit('close-modal')
                errors.value = {}
                form.new_password = ''
            },
            onError: (error) => {
                errors.value = error
            }
        }
    )
}
</script>

<style scoped>

</style>
